import { render, staticRenderFns } from "./VideoBox.vue?vue&type=template&id=f325f8da&scoped=true&"
import script from "./VideoBox.vue?vue&type=script&lang=js&"
export * from "./VideoBox.vue?vue&type=script&lang=js&"
import style0 from "./VideoBox.vue?vue&type=style&index=0&id=f325f8da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f325f8da",
  null
  
)

export default component.exports